import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Select, Checkbox } from "antd";

import areasActions from "../../../redux/areas/actions";
import { useProjectState } from "../../../context/stateContext";
import DatePickerComponent from "../../Common/DatePicker/DatePicker";
import "./index.css";

const { getAreas, getTurnOverByAreas } = areasActions;
const { Option } = Select;

const AreasInfoActions = () => {
  const dispatch = useDispatch();
  const [selectedAreas, setSelectedAreas] = useState(["all"]);

  const {
    selectedOrganization,
    allSectedRestaurants,
    setAllSelectedRestaurants,
    startDate,
    endDate,
    showPaymentMethods,
    setShowPaymentMethods,
  } = useProjectState();

  const { restaurants, organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );

  const { areas } = useSelector((state) => state.areasReducer);

  let filteredIds = [];
  if (selectedAreas.includes("all")) {
    filteredIds = areas.map((item) => item.id);
  } else {
    filteredIds = selectedAreas.map((name) => {
      const area = areas.find((item) => item.name === name);
      return area ? area.id : null;
    });
  }

  const defaultOrganization = organizations.filter(
    (itemInArray) => itemInArray.id === selectedOrganization
  );

  const defaultTouchSaleRestaurantId =
    defaultOrganization[0]?.defaultTouchSaleRestaurantId;
  useEffect(() => {
    if (defaultOrganization.length > 0) {
      setAllSelectedRestaurants([
        defaultOrganization[0]?.defaultTouchSaleRestaurantId,
      ]);
      dispatch(
        getAreas(defaultOrganization[0]?.defaultTouchSaleRestaurantId, true)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization, defaultTouchSaleRestaurantId]);

  useEffect(() => {
    if (areas.length !== 0) {
      const timer = setTimeout(() => {
        if (selectedAreas.length !== 0) {
          dispatch(getTurnOverByAreas(filteredIds, startDate, endDate));
        }
      }, 1000);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, selectedAreas.length, areas, selectedAreas[0]]);

  const handleOnChangeRestaurant = (restaurant) => {
    setAllSelectedRestaurants([restaurant]);
    setSelectedAreas(["all"]);
    dispatch(getAreas(restaurant, true));
  };

  const handleOnSelectAreas = (area) => {
    if (area === "all") {
      setSelectedAreas([area]);
    } else if (selectedAreas.includes("all")) {
      setSelectedAreas([area]);
    } else {
      setSelectedAreas((prevSelectedAreas) => [...prevSelectedAreas, area]);
    }
  };

  const handleDeSelectAreas = (areaToRemove) => {
    setSelectedAreas((prevSelectedAreas) => {
      return prevSelectedAreas.filter((area) => !areaToRemove.includes(area));
    });
  };

  return (
    <>
      <div className="areas-info-action-buttons-container">
        {defaultOrganization[0]?.multipleRestaurants && (
          <Select
            showSearch={false}
            virtual={false}
            key="areasInfoRestaurantSelect"
            placeholder="Изберете ресторант"
            onChange={handleOnChangeRestaurant}
            value={allSectedRestaurants}
            className="areas-info-action-buttons"
          >
            {restaurants?.map((restaurant, index) => (
              <Option
                key={restaurant.id}
                value={restaurant.id}
                className="areas-info-select-option"
              >
                {restaurant.name}
              </Option>
            ))}
          </Select>
        )}
        <DatePickerComponent />
      </div>
      <div className="areas-info-select-container">
        <Select
          disabled={allSectedRestaurants[0] === undefined}
          virtual={false}
          key="salesInfoAreasSelect"
          mode="multiple"
          placeholder="Изберете обект"
          onSelect={handleOnSelectAreas}
          onDeselect={handleDeSelectAreas}
          value={selectedAreas}
          maxTagCount={6}
          className="areas-info-select-areas"
        >
          <Option key="all" value="all">
            Всички
          </Option>
          {areas &&
            areas.map((area) => (
              <Option key={area.name} value={area.name}>
                {area.name}
              </Option>
            ))}
        </Select>
        <Checkbox
          checked={showPaymentMethods}
          onChange={() => setShowPaymentMethods(!showPaymentMethods)}
          className="areas-checkbox-only-with-value"
        >
          <p className="areas-checkbox-text">Видове Плащания</p>
        </Checkbox>
      </div>
    </>
  );
};

export default AreasInfoActions;
